import { render, staticRenderFns } from "./large-text-section.vue?vue&type=template&id=bbd8c96e&scoped=true&"
import script from "./large-text-section.vue?vue&type=script&lang=js&"
export * from "./large-text-section.vue?vue&type=script&lang=js&"
import style0 from "./large-text-section.vue?vue&type=style&index=0&id=bbd8c96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd8c96e",
  null
  
)

export default component.exports